module.exports = __webpack_public_path__ + "img/login_logo.f7933b93.png";